import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { SessionStorageService } from 'ngx-webstorage';
import { CookieService } from 'ngx-cookie-service';
import { AppConstants } from '../constant'

@Injectable({
  providedIn: 'root'
})
export class LoginserviceService {

  constructor(private http: Http, private session: SessionStorageService, private cookieService: CookieService) { }

  check(username, password) {
    return new Promise((resolve, reject) => {
      const url = AppConstants.baseUrl+'MemberLogin.asp';

      const body = { 
            'username': username,
            'password': password
          };

      this.http.post(url, body).subscribe((res: any) => {
      const response = JSON.parse(res._body);
      if (response.status == 'success') {
          resolve(response);
        } else { reject(response); }
      });
    });
}
 }
